
import React from 'react';
import { Box, Container, Typography } from '@mui/material';


const privacy ={"PrivacyPolicy": {
    "1. Introduction": {
      "1.1. Purpose": "This Privacy Policy explains how MindMapper AI collects, uses, and protects your personal information.",
      "1.2. Acceptance": "By using MindMapper AI, you consent to the collection and use of your information as described."
    },
    "2. Information We Collect": {
      "2.1. Personal Information": "When you register, we collect your email address and authentication details.",
      "2.2. Dream Logs": "Users can log their dreams, which may include personal thoughts and experiences.",
      "2.3. Usage Data": "We collect information on how you interact with the app, including features used and time spent.",
      "2.4. Device Information": "Data about your device, such as operating system and device identifiers, may be collected."
    },
    "3. How We Use Your Information": {
      "3.1. To Provide Services": "To operate and maintain MindMapper AI, including processing dream logs and delivering meditations.",
      "3.2. Personalization": "To personalize your experience and provide tailored content based on your inputs.",
      "3.3. Communication": "To send important updates, newsletters, and promotional materials with your consent.",
      "3.4. Analytics": "To analyze usage patterns and improve the app's functionality and user experience."
    },
    "4. Sharing Your Information": {
      "4.1. Service Providers": "We may share your information with third-party service providers who assist in operating the app.",
      "4.2. Legal Requirements": "We may disclose your information if required by law or to protect our rights.",
      "4.3. Business Transfers": "In the event of a merger, acquisition, or sale of assets, your information may be transferred."
    },
    "5. Data Security": {
      "5.1. Measures": "We implement security measures to protect your data from unauthorized access and breaches.",
      "5.2. Limitations": "Despite our efforts, no security measures are perfect, and we cannot guarantee absolute security."
    },
    "6. Your Rights": {
      "6.1. Access and Correction": "You can access and update your personal information through your account settings.",
      "6.2. Data Deletion": "You have the right to request the deletion of your personal data, subject to certain conditions.",
      "6.3. Opt-Out": "You can opt-out of receiving promotional communications at any time."
    },
    "7. Children's Privacy": {
      "7.1. Age Restriction": "MindMapper AI is not intended for use by individuals under the age of 13.",
      "7.2. Parental Consent": "We do not knowingly collect personal information from children without parental consent."
    },
    "8. Third-Party Links": {
      "8.1. External Sites": "Our app may contain links to third-party websites. We are not responsible for their privacy practices.",
      "8.2. Recommendations": "We do not endorse any third-party sites and encourage you to review their privacy policies."
    },
    "9. Changes to Privacy Policy": {
      "9.1. Updates": "We may update this Privacy Policy from time to time. Changes will be effective upon posting.",
      "9.2. Notification": "Significant changes will be communicated through the app or via email."
    },
    "10. Contact Us": {
      "10.1. Support": "If you have any questions or concerns about this Privacy Policy, please contact us at help@mmai.live."
    }
  }
}
  
function DisplayPrivacy () {

return (
    <Box sx={{ py: 5 }}>
        <Container maxWidth="md" sx={{ mb: 10 }}>
            <Typography variant="h4" align="center" gutterBottom>
            Privacy Policy
            </Typography>
            <Typography variant="h6" align="center" gutterBottom>
            Last updated: Dec 15th 2024
            </Typography>
            {Object.keys(privacy.PrivacyPolicy).map((section, index) => (
            <Box key={index} sx={{ mt: 2 }}>
                <Typography variant="h5" gutterBottom>
                {section}
                </Typography>
                {Object.keys(privacy.PrivacyPolicy[section]).map((subSection, subIndex) => (
                <Box key={subIndex} sx={{ mt: 1 }}>
                    <Typography variant="h6" gutterBottom>
                    {subSection}
                    </Typography>
                    <Typography>{privacy.PrivacyPolicy[section][subSection]}</Typography>
                </Box>
                ))}
            </Box>
            ))}
        </Container>

    </Box>

)

}

export default DisplayPrivacy;
